// Chakra Imports
// Custom Icons
import React from "react";

import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useColorMode } from "@chakra-ui/react";

export default function FixedPlugin(props) {
  const { ...rest } = props;
  const { colorMode, toggleColorMode } = useColorMode();
  const [darkmode, setDarkmode] = React.useState(
    colorMode === 'dark'
  );

  // Sync Chakra's color mode with Tailwind's 'dark' class
  React.useEffect(() => {
    if (colorMode === 'dark') {
      document.body.classList.add('dark');
      setDarkmode(true);
    } else {
      document.body.classList.remove('dark');
      setDarkmode(false);
    }
  }, [colorMode]);

  return (
    <div className='fixed bottom-3 right-3 flex h-14 w-14 z-20 items-center justify-center rounded-full border-[2px] border-white hover:border-gray-600 bg-gradient-to-b from-[#868CFF] to-brand-500 dark:!border-navy-800 hover:dark:!border-gray-800 '>
      <button
        className="border-px flex w-full h-full items-center justify-center rounded-full transition-all"
        onClick={toggleColorMode}
        {...rest}
      >
        {/* // left={document.documentElement.dir === "rtl" ? "35px" : ""}
        // right={document.documentElement.dir === "rtl" ? "" : "35px"} */}
        <div className="cursor-pointer text-gray-600">
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-white" />
          )}
        </div>
      </button>
    </div>
  );
}
